import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_08283616 from 'nuxt_plugin_plugin_08283616' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_d55bcc58 from 'nuxt_plugin_cookieuniversalnuxt_d55bcc58' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_vuesocialsharingplugin_910681b6 from 'nuxt_plugin_vuesocialsharingplugin_910681b6' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_pluginrouting_2a159f1a from 'nuxt_plugin_pluginrouting_2a159f1a' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_21e99ad6 from 'nuxt_plugin_pluginmain_21e99ad6' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_plugin_98ac6938 from 'nuxt_plugin_plugin_98ac6938' // Source: ./nuxt-mobile-detect/plugin.js (mode: 'all')
import nuxt_plugin_lazySizes_3370e2b8 from 'nuxt_plugin_lazySizes_3370e2b8' // Source: ./lazySizes.js (mode: 'client')
import nuxt_plugin_translations_2c4006c2 from 'nuxt_plugin_translations_2c4006c2' // Source: ../plugins/translations.js (mode: 'all')
import nuxt_plugin_ctxinject_6c782eea from 'nuxt_plugin_ctxinject_6c782eea' // Source: ../plugins/ctx-inject.js (mode: 'all')
import nuxt_plugin_ctxinjectserver_77df25f4 from 'nuxt_plugin_ctxinjectserver_77df25f4' // Source: ../plugins/ctx-inject-server.js (mode: 'server')
import nuxt_plugin_utils_1ea7651c from 'nuxt_plugin_utils_1ea7651c' // Source: ../plugins/utils.js (mode: 'all')
import nuxt_plugin_chat_12dc7b69 from 'nuxt_plugin_chat_12dc7b69' // Source: ../plugins/chat.js (mode: 'client')
import nuxt_plugin_toast_bdf93834 from 'nuxt_plugin_toast_bdf93834' // Source: ../plugins/toast.js (mode: 'client')
import nuxt_plugin_linkedin_73b0df03 from 'nuxt_plugin_linkedin_73b0df03' // Source: ../plugins/linkedin.js (mode: 'client')
import nuxt_plugin_pinterest_35c2be93 from 'nuxt_plugin_pinterest_35c2be93' // Source: ../plugins/pinterest.js (mode: 'client')
import nuxt_plugin_watchlist_b2910940 from 'nuxt_plugin_watchlist_b2910940' // Source: ../plugins/watchlist.js (mode: 'client')
import nuxt_plugin_aos_78651e70 from 'nuxt_plugin_aos_78651e70' // Source: ../plugins/aos.js (mode: 'client')
import nuxt_plugin_initGoogleMaps_b633d8be from 'nuxt_plugin_initGoogleMaps_b633d8be' // Source: ../plugins/initGoogleMaps.js (mode: 'client')
import nuxt_plugin_oxomi_e580372a from 'nuxt_plugin_oxomi_e580372a' // Source: ../plugins/oxomi.js (mode: 'client')
import nuxt_plugin_lightbox_449b2fac from 'nuxt_plugin_lightbox_449b2fac' // Source: ../plugins/lightbox.js (mode: 'client')
import nuxt_plugin_vuexpersist_25bdab30 from 'nuxt_plugin_vuexpersist_25bdab30' // Source: ../plugins/vuex-persist.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule
const baseStoreOptions = { preserveState: process.client }

function registerModule (path, rawModule, options = {}) {
  return originalRegisterModule.call(this, path, rawModule, { ...baseStoreOptions, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Bette","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"name":"p:domain_verify","content":"f5b59b3150f24521be31447a6139142c"},{"name":"yandex-verification","content":"5fa592babfbdc13b"},{"name":"google-site-verification","content":"UR9OSrRBDY6OBp77nL-mknNwzTccN2Cf9kF-ZkKNWu4"},{"name":"facebook-domain-verification","content":"6wa3jykmk1ilx50dv0tthioopyare2"}],"script":[{"src":"https:\u002F\u002Fapp.usercentrics.eu\u002Fbrowser-ui\u002Flatest\u002Floader.js","id":"usercentrics-cmp","data-settings-id":"IjmVFmTdS_","async":true}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_08283616 === 'function') {
    await nuxt_plugin_plugin_08283616(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_d55bcc58 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_d55bcc58(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_910681b6 === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_910681b6(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_2a159f1a === 'function') {
    await nuxt_plugin_pluginrouting_2a159f1a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_21e99ad6 === 'function') {
    await nuxt_plugin_pluginmain_21e99ad6(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_98ac6938 === 'function') {
    await nuxt_plugin_plugin_98ac6938(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazySizes_3370e2b8 === 'function') {
    await nuxt_plugin_lazySizes_3370e2b8(app.context, inject)
  }

  if (typeof nuxt_plugin_translations_2c4006c2 === 'function') {
    await nuxt_plugin_translations_2c4006c2(app.context, inject)
  }

  if (typeof nuxt_plugin_ctxinject_6c782eea === 'function') {
    await nuxt_plugin_ctxinject_6c782eea(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_ctxinjectserver_77df25f4 === 'function') {
    await nuxt_plugin_ctxinjectserver_77df25f4(app.context, inject)
  }

  if (typeof nuxt_plugin_utils_1ea7651c === 'function') {
    await nuxt_plugin_utils_1ea7651c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_chat_12dc7b69 === 'function') {
    await nuxt_plugin_chat_12dc7b69(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_bdf93834 === 'function') {
    await nuxt_plugin_toast_bdf93834(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_linkedin_73b0df03 === 'function') {
    await nuxt_plugin_linkedin_73b0df03(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pinterest_35c2be93 === 'function') {
    await nuxt_plugin_pinterest_35c2be93(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_watchlist_b2910940 === 'function') {
    await nuxt_plugin_watchlist_b2910940(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_aos_78651e70 === 'function') {
    await nuxt_plugin_aos_78651e70(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_initGoogleMaps_b633d8be === 'function') {
    await nuxt_plugin_initGoogleMaps_b633d8be(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_oxomi_e580372a === 'function') {
    await nuxt_plugin_oxomi_e580372a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lightbox_449b2fac === 'function') {
    await nuxt_plugin_lightbox_449b2fac(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersist_25bdab30 === 'function') {
    await nuxt_plugin_vuexpersist_25bdab30(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
